export default {
    warehouse: 'Almacén',
    'material-name-or-num': 'Número o nombre de materia',
    'loss-ratio': 'Porcentaje de deterioro',
    'count': 'Número',
    'produced-quantity': 'Cantidad producida',
    
    'save': 'Guardar',
    'edit': 'Editar',

    'back-to-the-bond': 'Volver a bono',
    
    'delete-raw-material': 'Eliminar materia prima',
    'are-you-sure-you-want-to-delete-the-raw-material': '¿Estas seguro de eliminar materia prima?',

    'context-menu': {
        edit: 'Editar',
        delete: 'Eliminar',
    },

    headers: {
        'no': 'Número',
        'warehouse': 'Almacén',
        'material': 'Materia',
        'count': 'Número',
        'quantity': 'Cantidad',
        'cost-of-one': 'Coste de unidad',
        'cost': 'Coste',
    },
    total_cost: 'Coste total: ',
    'product-is-updated-successfully': 'El producto ha sido actualizado con éxito.'
}